var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center flex-column fill-height full-width"},[_c('div',[_c('img',{attrs:{"src":require('@/assets/chat/no-messages.svg'),"alt":"no-messages.svg"}})]),_c('div',{staticClass:"messages-preview-title"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }